import _ from "lodash"

import executeQuery from "#lib/db"
import { log } from "#debug"

import { RecipeInstruction } from "#types"

export const getInstructions = async ({ id }: { id: string }) => {
	const list = await executeQuery({
		query: `select * from recipe_instructions where recipeID=${id} and isActive=1`,
	})

	return list
}

export const addInstructions = async (body: RecipeInstruction) => {
	const query = `
		insert into recipe_instructions(
			recipeID,
			sequence,
			instruction,
			isActive
		) values (
			${body.recipeID},
			${body.sequence},
			'${body.instruction}',
			1
		)
	`

	log(query)

	const results = await executeQuery({ query })

	return results
}

export const patchInstructions = async (body: RecipeInstruction) => {
	let query = `update recipe_instructions set `

	// NUMERICS
	if (_.has(body, "sequence")) {
		query += ` sequence=${body.sequence}`
	}
	if (_.has(body, "isActive")) {
		query += ` isActive=${body.isActive}`
	}
	// VARCHARS
	if (_.has(body, "instruction")) {
		query += ` instruction='${body.instruction}'`
	}

	query += ` where recipeInstructionsID=${body.recipeInstructionsID} and recipeID=${body.recipeID}`

	log(query)

	const results = await executeQuery({ query })

	return results
}
